import BadgeMask from '-/Badge/BadgeMask';
import Avatar from '-/Custom/Avatar';
import { View } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import Text from '@/components/UI/Text';
import { type FragmentOf, graphql, readFragment } from '@/gql/graphql';
import pluralize from '@/utils/pluralize';
import Box from '../UI/Box';

export const BadgeListItemFragment = graphql(
  /* GraphQL */ `
    fragment BadgeListItem on badge {
      id
      title
      color
      is_official
      badge_assignees_aggregate(
        order_by: { created_at: desc }
        where: $badgeAssigneesWhere
      ) @include(if: $includeBadgeAssignees) {
        aggregate {
          count
        }
      }
    }
  `,
);

const style = StyleSheet.create((theme) => ({
  separator: {
    backgroundColor: theme.colors.typographySecondary,
    borderRadius: theme.borderRadius.full,
    height: theme.size(1),
    width: theme.size(1),
  },
}));

export default function BadgeListItem({
  fragment,
}: {
  fragment: FragmentOf<typeof BadgeListItemFragment>;
}) {
  const badge = readFragment(BadgeListItemFragment, fragment);

  return (
    <>
      <BadgeMask size="md" color={badge.color}>
        <Avatar
          id=""
          ring={false}
          size="md"
          color={badge?.color}
          name={badge?.title || ''}
        />
      </BadgeMask>
      <Box flexShrink={1} minWidth={0}>
        <Box space="md" direction="horizontal" alignItems="center" minWidth={0}>
          <Text type="itemTitle" flexShrink={1} numberOfLines={1}>
            {badge?.title}
          </Text>
          {badge.is_official ? (
            <>
              <View style={style.separator} />
              <Text type="itemSecondarySubtitle">official</Text>
            </>
          ) : null}
        </Box>
        {badge?.badge_assignees_aggregate ? (
          <Text size="sm" variant="typographySecondary" numberOfLines={1}>
            {badge.badge_assignees_aggregate.aggregate?.count}{' '}
            {pluralize(
              'assignment',
              badge.badge_assignees_aggregate.aggregate?.count,
            )}
          </Text>
        ) : null}
      </Box>
    </>
  );
}
